import { combineReducers } from "redux";
import accountBalance from "./reducer.accountBalance.jsx";
import accountSettings from "./reducer.accountSettings.jsx";
import activity_logs from "./reducer.activityLogs.jsx";
import additional_object_data from "./reducer.additionalObjectData.jsx";
import app from "./reducer.app.jsx";
import assignees from "./reducer.assignees";
import attachments from "./reducer.attachments.jsx";
import availability_records from "./reducer.availabilityRecords.jsx";
import availability_types from "./reducer.availabilityTypes.jsx";
import billingOrder from "./reducer.billingOrder.jsx";
import billingPaymentMethod from "./reducer.billingPaymentMethod.jsx";
import blocking_interface from "./reducer.blockingInterface.jsx";
import calendarEventParticipants from "./reducer.calendarEventParticipants.js";
import calendarEvents from "./reducer.calendarEvents";
import calendars from "./reducer.calendars.js";
import cancellationPasswordVerified from "./reducer.cancellationPasswordVerified.jsx";
import cancellationRequestObject from "./reducer.cancellationRequestObject.jsx";
import cancelSubscriptionAccountStats from "./reducer.cancelSubscriptionAccountStats.jsx";
import comments from "./reducer.comments.jsx";
import companies from "./reducer.companies.jsx";
import config_options from "./reducer.configOptions.jsx";
import conversation_messages from "./reducer.conversationMessages.jsx";
import conversations from "./reducer.conversations.jsx";
import countriesAndStates from "./reducer.countriesAndStates.jsx";
import currencies from "./reducer.currencies.jsx";
import cursor_pagination from "./reducer.cursorPagination.jsx";
import daysOff from "./reducer.daysOff.jsx";
import discussions from "./reducer.discussions.jsx";
import discussionsData from "./reducer.discussionsData";
import { preparingDownloadAllAttachments } from "./reducer.downloads.jsx";
import estimates from "./reducer.estimates.jsx";
import expense_categories from "./reducer.expenseCategories.jsx";
import expenses from "./reducer.expenses.jsx";
import favorites from "./reducer.favorites.jsx";
import feature_flags from "./reducer.featureFlags.jsx";
import featurePointers from "./reducer.featurePointers.jsx";
import files from "./reducer.files.jsx";
import files_filters from "./reducer.filesFilters";
import folders from "./reducer.folders";
import forms from "./reducer.forms.jsx";
import ghostTasks from "./reducer.ghostTasks.js";
import httpMessages from "./reducer.httpMessages.jsx";
import initial_data from "./reducer.initialData.jsx";
import instance from "./reducer.instance.jsx";
import invoices from "./reducer.invoices.jsx";
import job_types from "./reducer.jobTypes.jsx";
import labels from "./reducer.labels.jsx";
import languages from "./reducer.languages.jsx";
import last_visit from "./reducer.lastVisit.jsx";
import logged_user from "./reducer.loggedUser.jsx";
import notebooks from "./reducer.notebooks.js";
import notes from "./reducer.notes.jsx";
import pagination from "./reducer.pagination.jsx";
import personalized_config_options from "./reducer.personalizedConfigOptions.jsx";
import projectCategories from "./reducer.projectCategories.jsx";
import projectCompletedTasks from "./reducer.projectCompletedTasks.jsx";
import projectOpenTasks from "./reducer.projectOpenTasks.jsx";
import projects, { projects_id_name } from "./reducer.projects.jsx";
import projectHourlyRates from "./reducer.projectsHourlyRates";
import projectTaskLabels from "./reducer.projectTaskLabels.jsx";
import project_template_elements from "./reducer.projectTemplateElements.jsx";
import project_templates from "./reducer.projectTemplates.jsx";
import project_template_task_dependencies from "./reducer.projectTemplateTaskDependencies.jsx";
import reactions from "./reducer.reactions.jsx";
import recurringTasks from "./reducer.recurringTasks.jsx";
import reminders from "./reducer.reminders.jsx";
import report from "./reducer.report.jsx";
import sampleProjects from "./reducer.sampleProjects.jsx";
import shortcuts from "./reducer.shortcuts";
import stopwatches from "./reducer.stopwatches.jsx";
import subscription from "./reducer.subscription.jsx";
import subscriptionAddOns from "./reducer.subscriptionAddOns.jsx";
import subscriptionPlan from "./reducer.subscriptionPlans.jsx";
import subtasks from "./reducer.subtasks.jsx";
import system_notifications from "./reducer.systemNotifications";
import task_dependencies from "./reducer.taskDependencies.jsx";
import task_lists from "./reducer.taskLists.jsx";
import tasks from "./reducer.tasks.jsx";
import teams from "./reducer.teams.js";
import time_records from "./reducer.timeRecords.jsx";
import uploaded_files from "./reducer.uploadedFiles.jsx";
import user_conversations from "./reducer.userConversations.jsx";
import user_internal_rates from "./reducer.userInternalRates.jsx";
import users from "./reducer.users.jsx";
import userWorkweeks from "./reducer.userWorkweeks.js";
import workload from "./reducer.workload.jsx";

const rootReducer = combineReducers({
  accountBalance,
  accountSettings,
  activity_logs,
  additional_object_data,
  app,
  attachments,
  assignees,
  billingOrder,
  billingPaymentMethod,
  blocking_interface,
  calendarEventParticipants,
  calendarEvents,
  calendars,
  cancellationPasswordVerified,
  cancellationRequestObject,
  cancelSubscriptionAccountStats,
  comments,
  companies,
  config_options,
  countriesAndStates,
  conversation_messages,
  conversations,
  currencies,
  cursor_pagination,
  daysOff,
  discussions,
  discussionsData,
  estimates,
  expense_categories,
  expenses,
  feature_flags,
  files,
  files_filters,
  forms,
  ghostTasks,
  httpMessages,
  initial_data,
  instance,
  invoices,
  job_types,
  labels,
  languages,
  last_visit,
  logged_user,
  notes,
  notebooks,
  pagination,
  personalized_config_options,
  preparingDownloadAllAttachments,
  project_template_elements,
  project_template_task_dependencies,
  projectCategories,
  projectCompletedTasks,
  projectOpenTasks,
  projects,
  projects_id_name,
  projectTaskLabels,
  reactions,
  recurringTasks,
  report,
  project_templates,
  sampleProjects,
  subscription,
  subscriptionAddOns,
  subscriptionPlan,
  subtasks,
  task_dependencies,
  task_lists,
  tasks,
  teams,
  time_records,
  uploaded_files,
  users,
  user_conversations,
  userWorkweeks,
  stopwatches,
  workload,
  availability_types,
  availability_records,
  featurePointers,
  user_internal_rates,
  reminders,
  favorites,
  system_notifications,
  shortcuts,
  projectHourlyRates,
  folders,
});

export default rootReducer;
